<template>
  <div class="bg-gray-400 grow flex flex-row">
    <img v-if='!enableGallery && !isAtlas' class="object-contain w-full" :class='sizeClass' :src='thumbnailUrl'>
    <div class="grow propertyform-sprite-gallery" >
      <choose-or-upload-video game-id='chezzer' @select="select" @upload-video='onUploadVideo' :uploaded-videos='uploadedVideos' />
    </div>
  </div>
</template>
<script>
import ChooseOrUploadVideo from '@ui/organisms/ChooseOrUploadVideo.vue';
import { abstractField } from "vue-form-generator";

export default {
  mixins: [ abstractField ],
  inject:['api'],
  data() {
    const enableGallery = this.schema.enableGallery;
    const gamedata = this.vfg.schema.data.partutil.gamedata.gamedata;
    if (typeof(gamedata.uploadedVideos) === 'undefined') {
      this.$set(gamedata, 'uploadedVideos', []);
    }
    const uploadedVideos = gamedata.uploadedVideos;
    return {
      enableGallery,
      uploadedVideos
    }
  },
  mounted() {
  },
  methods: {
    select({id,...rest}) {
      console.log('select',id,rest);
      console.log('aaaaaaaaa', this.vfg.schema);
      console.log('aaaaaaaaa', this.vfg.schema.data);
      if (this.enableGallery) {
        const {component} = this.vfg.schema.data;
        const thumbnail = this.api.makeThumbnailUrlEditor(rest.thumbnail);
        const {widith,height} = rest;
        console.log('thumbes', thumbnail);
        this.$set(component, 'thumbnail', rest.thumbnail);
        this.$set(component, 'width', rest.width);
        this.$set(component, 'height', rest.height);
        this.value = id;
      }
    },
    onUploadVideo(video) {
      const {partutil} = this.vfg.schema.data;
      const gamedata = partutil.gamedata.gamedata;
      if (typeof(gamedata.uploadedVideos) === 'undefined') {
        gamedata.uploadedVideos = [];
      }
      gamedata.uploadedVideos.push(video);
    }
  },
  computed:{
    component() {
      const {component} = this.vfg.schema.data;
      return component;
    },
    thumbnailUrl() {
      return this.api.makeThumbnailUrlEditor(this.component.thumbnail);
    },
    sizeClass() {
      if (this.schema.spriteSize) {
        return ['h-' + this.schema.spriteSize];
      } else {
        return ['h-32'];
      }
    },
    isAtlas() {
      const {component} = this.vfg.schema.data;
      return !!component.atlas;
    }
  },
  components: {
    ChooseOrUploadVideo,
  }
}
</script>
